import React from "react";
import LeftPaneText from "./LeftPaneText";
import RightPaneImg from "./RightPaneImg";

const TotoContainer = () => {
  return (
    <section className="portfolio">
      <LeftPaneText />
      <RightPaneImg />
    </section>
  );
};

export default TotoContainer;
